import { Box } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { useRef } from 'react';
import classes from './MenuWrapper.module.css.mjs';

const MenuWrapper = (props) => {
  const { children, currentType, menuType, setMenuType, isOpen: isOpenProp } = props;
  const menuContentRef = useRef(null);
  const isOpen = isOpenProp ?? menuType === currentType;
  const handleOverlayClickCapture = (e) => {
    if (!isOpen) return;
    if (e.target === e.currentTarget) {
      setMenuType?.(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: clsx(classes.menuPositionWrapper, isOpen && classes.menuPositionWrapperBody),
      "data-open": isOpen ? "true" : "false",
      hidden: !isOpen,
      "aria-hidden": !isOpen ? true : void 0,
      ...{ inert: !isOpen ? "" : void 0 },
      onClickCapture: handleOverlayClickCapture
    },
    /* @__PURE__ */ React.createElement("div", { ref: menuContentRef }, children)
  );
};

export { MenuWrapper };
